export default "__VITE_ASSET__BRW3Qe$R__"